module.exports = "<div class='footerContainer'> \r\n    <div class='footerContent'>\r\n      {{footerText}}\r\n    </div>\r\n  </div>"